import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Backstabbing",
  "description": "",
  "published": "2007-01-30T00:00:00.000Z",
  "redirect_from": ["/blog/backstabbing/swizec/301"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Through my recent love of one band `}<a parentName="p" {...{
        "href": "http://www.dresdendolls.com/"
      }}>{`The Dresden Dolls`}</a>{` I discovered `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=vY2WLMf0F_c"
      }}>{`a funny little video`}</a>{` they did with `}<a parentName="p" {...{
        "href": "http://www.panicatthedisco.com/"
      }}>{`Panic! At The Disco`}</a>{`, which nicely shows the relationship between mimes and emos ... It's a bit strange, but I'm sure deep down they realise they're pretty much the same evil crap.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      